import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { SystemSettingService } from "../../services/system-setting/system-setting.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
let MaintenanceGuard = class MaintenanceGuard {
    systemSettingService;
    router;
    constructor(systemSettingService, router) {
        this.systemSettingService = systemSettingService;
        this.router = router;
    }
    canActivate(route, state) {
        return this.handleActivation();
    }
    canActivateChild(childRoute, state) {
        return this.handleActivation();
    }
    handleActivation() {
        if (this.systemSettingService.isMaintenanceModeEnabled() && !this.systemSettingService.getMaintenanceAcknowledged()) {
            return this.router.createUrlTree([`/${AppRoutingConstants.MAINTENANCE_PATH}`]);
        }
    }
    static ctorParameters = () => [
        { type: SystemSettingService },
        { type: Router }
    ];
};
MaintenanceGuard = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], MaintenanceGuard);
export { MaintenanceGuard };
